import React, { useState, useContext } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import AboutSection from "../components/about-section"
import AboutNav from "../components/about-nav"
import useRedirectToLang from "../hooks/useRedirectToLang"
import { ViewportContext } from "../contexts/viewport-context"
import Navigation from "../components/navigation"

const AboutZhPage = () => {
  useRedirectToLang("/cn/about")
  const [pageNavigationState, setPageNavigationState] = useState("we")
  const dimensions = useContext(ViewportContext)

  const pageNavigation = ["we", "philosophy", "locations", "team", "csr"]

  const handleButtonClick = index => {
    if (pageNavigation[index] !== pageNavigationState) {
      setPageNavigationState(pageNavigation[index])
      if (window.innerWidth < 641) {
        window.scrollTo(0, 0)
      }
    }
  }

  return (
    <>
      <Layout width={dimensions[0]}>
        <SEO title="关于" lang="zh" />
        <AboutNav
          navState={pageNavigationState}
          buttonClick={handleButtonClick}
          lang="cn"
          width={dimensions[0]}
        />
        <AboutSection
          navState={pageNavigationState}
          lang="cn"
          dimensions={dimensions}
        />
      </Layout>
      <Navigation path="/cn/about" lang="cn" width={dimensions[0]} />
    </>
  )
}

export default AboutZhPage
